import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import {
  ServicesSubSectionContainer,
  ServicesSubSectionHeader,
  ServicesSubSectionMainContent,
  ServicesSubSectionRow,
  ServicesSubSectionTitle,
  ServicesSubSectionValue,
} from '../../services/services-subsection/services-subsection.styles';
import { Heading, Value } from './insurance-details-summary.styles';
import { useStore } from '../../../stores/store';
import InsuranceTooltip from '../../../common/insurance-tooltip/insurance-tooltip.component';
import { getFormattedPrice } from '../../../utils/price/get-formatted-price';
import { Shipment } from '../../../models/parcelDeliveryMiles';
import { getCountryTranslationKey } from '../../../utils/translations/translations.utils';

interface Props {
  shipment: Shipment | undefined;
  hideTooltip?: boolean;
}

const InsuranceDetailsSummary = ({ shipment, hideTooltip }: Props) => {
  const {
    userStore: { getCurrencySymbol },
  } = useStore();

  const { t } = useTranslation();

  if (!shipment) return;

  const isDomestic = shipment.sender?.country === shipment.recipient?.country;
  const departureCountryCode = shipment.sender?.country;

  const { insurance, insurance_fee: insuranceFee } = shipment;

  const insuranceAmountTransKey = isDomestic
    ? 'declared_value'
    : getCountryTranslationKey('insurance_amount', departureCountryCode);

  return (
    <ServicesSubSectionContainer>
      <ServicesSubSectionHeader>
        <Heading>
          {t(getCountryTranslationKey('insurance', departureCountryCode))}
          {!hideTooltip && <InsuranceTooltip />}
        </Heading>
      </ServicesSubSectionHeader>
      <ServicesSubSectionMainContent>
        <ServicesSubSectionRow>
          <ServicesSubSectionTitle>
            {t(insuranceAmountTransKey)}
          </ServicesSubSectionTitle>
          <ServicesSubSectionValue>{`${getFormattedPrice(insurance, getCurrencySymbol(shipment?.converted_price?.currency))}`}</ServicesSubSectionValue>
        </ServicesSubSectionRow>

        <ServicesSubSectionRow>
          <ServicesSubSectionTitle>
            {t(getCountryTranslationKey('insurance_fee', departureCountryCode))}
          </ServicesSubSectionTitle>
          <Value>
            {insuranceFee > 0 ? (
              `${getFormattedPrice(insuranceFee, getCurrencySymbol(shipment?.converted_price?.currency))}`
            ) : (
              <span>{t('free')}</span>
            )}
          </Value>
        </ServicesSubSectionRow>
      </ServicesSubSectionMainContent>
    </ServicesSubSectionContainer>
  );
};

export default observer(InsuranceDetailsSummary);
